const fetchActions = [['FETCH_DATA', 'FETCH_SUCCESSED', 'FETCH_FAILED', 'DESTROY'], []]

export default fetchActions
